export const SITE_URL = 'https://kriskindler.com';
export const DEFAULT_OG_IMAGE = `${SITE_URL}/images/hero-image.png`;

// Absolute URL for canonical/hreflang/og:url/JSON-LD. Trailing slashes
// are stripped everywhere except the domain root ("https://kriskindler.com/").
export const buildCanonicalUrl = (path = '/') => {
  const trimmed = path.replace(/\/+$/, '');
  return `${SITE_URL}${trimmed || '/'}`;
};
